import React from "react";
import Styles from "./passpracetice.module.css";

function Passpracetice({ pass ,children }) {
  return (
    <>
      {pass ? (
        <div className={Styles.body}>
          {children}
        </div>
      ) : (
        <div className={Styles.bodyFail}>
          {children}
        </div>
      )}
    </>
  );
}

export default Passpracetice;
